import React, { Component } from 'react'
import Link from '../Link'
import Menu from '../Menu'
import styles from './TourMap.css'
import mapImg from './map.svg'

export default class TourMap extends Component {
  handleTourWorkClick = (i) => {
    this.props.history.push('/tour/work/'+i)
  }
  render () {
    return (
      <div className={styles.cont}>
        <Menu logo={this.props.logo} menu={this.props.menu} linkBack/>
        <div className={styles.main}>
          <Map items={this.props.items}/>
        </div>
      </div>
    )
  }
}



class Map extends Component {
  state = {loaded: false}
  handleLoad = () => {
    this.setState({loaded: true})
  }
  render () {
    return (
      <div className={styles.mapCont}>
        <div className={styles.map}>
          <img className={styles.mapImg} src={mapImg} onLoad={this.handleLoad}/>
          {this.state.loaded ? (
            <div>
              <Link className={styles.room +' '+ styles.room1} to={'/tour/work/1'}>1</Link>
              <Link className={styles.room +' '+ styles.room2} to={'/tour/work/2'}>2</Link>
              <Link className={styles.room +' '+ styles.room3} to={'/tour/work/3'}>3</Link>
              <Link className={styles.room +' '+ styles.room4} to={'/tour/work/4'}>4</Link>
              <Link className={styles.room +' '+ styles.room5} to={'/tour/work/5'}>5</Link>
              <Link className={styles.room +' '+ styles.room6} to={'/tour/work/6'}>6</Link>
              <Link className={styles.room +' '+ styles.room7} to={'/tour/work/7'}>7</Link>
              <Link className={styles.room +' '+ styles.room8} to={'/tour/work/8'}>8</Link>
              <Link className={styles.room +' '+ styles.room9} to={'/tour/work/9'}>9</Link>
            </div>
          ) : null}
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/Rist/modules/TourMap/index.js